<template>
    <div class="user-profile">
        <form @submit.prevent="validateForm">

            <div class="form-row">
                <div class="form-group col required">
                    <label>Specialty / Specialties</label>
                    <multiple-select-dropdown :options="this.specialtyList" :selectedList="value.specialtyIds" @selected="updateSpecialty" :class="{
                        'is-invalid': specialtyHasError
                    }">
                    </multiple-select-dropdown>
                    <div class="invalid-feedback">
                        Please select at least one specialty.
                    </div>
                </div>
            </div>

            <div class="form-group required">
                <label>Hospital or Clinic Affiliation</label>
                <input type="text" name="affiliation" data-vv-validate-on="blur" data-vv-as="hospital or clinic affiliation" placeholder="Hospital or Clinic Affiliation" v-model="value.affiliation" v-validate="'required'" :class="{
                    'form-control': true,
                    'is-invalid':  validationErrors.has('affiliation')
                }">
                <small>E.g. IJN, Pantai, KPJ, etc</small>
                <div v-show="validationErrors.has('affiliation')" class="invalid-feedback">
                    {{ validationErrors.first('affiliation') }}
                </div>
            </div>

            <div class="form-group required">
                <label>Years Practicing</label>
                <input type="text" name="yearsPracticing" data-vv-validate-on="blur" data-vv-as="years practicing" placeholder="Years Practicing" v-model="value.yearsPracticing" v-validate="'required|numeric'" :class="{
                    'form-control': true,
                    'is-invalid':  validationErrors.has('yearsPracticing')
                }">
                <div v-show="validationErrors.has('yearsPracticing')" class="invalid-feedback">
                    {{ validationErrors.first('yearsPracticing') }}
                </div>
            </div>

            <div class="form-group required">
                <label>Education</label>
                <input type="text" name="education" data-vv-validate-on="blur" data-vv-as="education" placeholder="Education" v-model="value.education" v-validate="'required'" :class="{
                    'form-control': true,
                    'is-invalid':  validationErrors.has('education')
                }">
                <div v-show="validationErrors.has('education')" class="invalid-feedback">
                    {{ validationErrors.first('education') }}
                </div>
            </div>

            <div class="form-row">
                <div class="form-group col required">
                    <label>MMC Number (Malaysian Medical Certificate) <span class="text-primary" style="font-weight: bold;">(Mandatory)</span></label>
                    <input type="text" name="mmcNumber" data-vv-validate-on="blur" data-vv-as="MMC Number" placeholder="MMC Number" v-model="value.registrationNumber" v-validate="'required'" :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('mmcNumber')
                    }">
                    <small>Registered Number with Malaysian Medical Council</small>
                    <div v-show="validationErrors.has('mmcNumber')" class="invalid-feedback">
                        {{ validationErrors.first('mmcNumber') }}
                    </div>
                </div>
            </div>

            <div class="form-group required">
                <label>APC Number (Annual Practitioner Certificate) <span class="text-primary" style="font-weight: bold;">(Mandatory)</span></label>
                <input type="text" name="apcNumber" data-vv-validate-on="blur" data-vv-as="APC number" placeholder="APC Number (Annual Practitioner Certificate)" v-model="value.apcNumber" :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('apcNumber')
                    }">
                <div v-show="validationErrors.has('apcNumber')" class="invalid-feedback">
                    {{ validationErrors.first('apcNumber') }}
                </div>
            </div>

            <!-- <div class="form-group">
                    <label>APC Expiry Date</label>
                    <input type="text" name="apcExpiry" data-vv-as="APC expiry" data-vv-validate-on="blur"
                        v-model="value.apcExpiry"
                        v-mask="'##/##/####'"
                        v-validate="'required|date_format:DD/MM/YYYY'" placeholder="DD/MM/YYYY"
                        :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('apcExpiry')
                    }" />
                    <div v-show="validationErrors.has('apcExpiry')" class="invalid-feedback">
                        {{ validationErrors.first('apcExpiry') }}
                    </div>
                </div> -->

            <!-- <div class="form-group">
                    <label>Borang B Number</label>
                    <input type="text" name="borangBNumber" data-vv-validate-on="blur" data-vv-as="Borang B Number" placeholder="Borang B Number" v-model="value.borangBNumber" v-validate="'required'" :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('borangBNumber')
                    }">
                    <div v-show="validationErrors.has('borangBNumber')" class="invalid-feedback">
                        {{ validationErrors.first('borangBNumber') }}
                    </div>
                </div> -->

            <div class="form-group required">
                <label>Work Location Area</label>
                <input type="text" name="location" data-vv-validate-on="blur" data-vv-as="location" placeholder="Location" v-model="value.location" v-validate="'required'" :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('location')
                    }">
                <small>Please enter your location area in the format of (State / Area). E.g. KL / Ampang, KL / Subang, KL / PJ, KL / Damansara</small>
                <div v-show="validationErrors.has('location')" class="invalid-feedback">
                    {{ validationErrors.first('location') }}
                </div>
            </div>

            <div class="form-row required">
                <div class="form-group col required">
                    <label>Language(s) Speak</label>
                    <!-- <input type="text" name="languagesSpeak" data-vv-validate-on="blur" data-vv-as="languages speak" placeholder="Languages(s) Speak" v-model="value.languagesSpeak" v-validate="'required'" :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('languagesSpeak')
                    }">
                    <small>Separate multiple languages by a comma (,)</small>
                    <div v-show="validationErrors.has('languagesSpeak')" class="invalid-feedback">
                        {{ validationErrors.first('languagesSpeak') }}
                    </div> -->
                    <input style="opacity:0;" :class="{ 'is-invalid':  languagesSpeakHasError }">
                    <div v-show="languagesSpeakHasError" class="invalid-feedback mb-2">
                        The languages speak field is required.
                    </div>
                    <div class="row">
                        <div class="col-6 not-required" v-for="language in languages" :key="language">
                            <input type="checkbox" :id="language" :value="language" v-model="value.languagesSpeak">
                            <label class="ml-2" :for="language">{{ language }}</label>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import {
    mask
} from 'vue-the-mask';
import profileMixins from './profileMixins';
import multipleSelectDropdown from '@/components/multiple-select-dropdown';
import languages from '@/config/languages';
export default {
    'name': 'DoctorProfileComponent',
    'directives': {
        mask
    },
    'components': {
        multipleSelectDropdown
    },
    'props': {
        'value': Object
    },
    'mixins': [
        profileMixins
    ],
    data () {
        return {
            'specialtyList': [],
            'specialtyHasError': false,
            languages,
            'languagesSpeakHasError': false
        };
    },
    mounted () {
        this.retrieveSpecialtyList();
    },
    'methods': {
        validateForm () {
            if (this.value.specialtyIds.length === 0) {
                this.specialtyHasError = true;
                Promise.reject(new Error('Specialty cannot be empty'));
            } else {
                this.specialtyHasError = false;
            }

            if (this.value.languagesSpeak.length === 0) {
                this.languagesSpeakHasError = true;
                return Promise.reject(new Error('Languages Speak cannot be empty'));
            } else {
                this.languagesSpeakHasError = false;
            }

            return this.$validator.validateAll();
        },
        retrieveSpecialtyList () {
            this.axios.get('/Doctor/GetDoctorSpecialties').then(({
                data
            }) => {
                let list = data.data;

                // this.specialtyList = list.map((i) => {
                //     return {
                //         'value': i.si,
                //         'text': i.sn
                //     };
                // });
                for (let doctorSpecialty of list) {
                    this.specialtyList.push({
                        'value': doctorSpecialty.si,
                        'text': JSON.parse(doctorSpecialty.sn).en
                    });
                }
            });
        },
        // listen change of specialty, update,
        updateSpecialty (selectedValue) {
            // find index of selectedItem
            let selectedIndex = this.value.specialtyIds.findIndex((s) => s === selectedValue);

            if (selectedIndex > -1) {
                this.value.specialtyIds.splice(selectedIndex, 1);
            } else {
                this.value.specialtyIds.push(selectedValue);
            }
        }
    }
};
</script>

<style>

</style>
